module.exports = __webpack_public_path__ + "img/Adaptive.b1434f86.png";